<div class="p-grid">
  <div class="p-col-12">
    <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="readonly"></p-steps>
  </div>
  <div class="p-col-12">
    <ng-content></ng-content>  
  </div>
</div>
